import { AbstractCategoryModel } from "@app/catalog-common";

export class CategoryNotFoundMessage {
    public category: AbstractCategoryModel;
    
    constructor(category: AbstractCategoryModel)
    {
        this.category = category;
    }
}